import React from 'react'
import { UIButton, type UIButtonProps } from './ui-button'

export interface UIButtonPrimaryProps extends
  Omit<UIButtonProps, 'variant'> {
}

/**
 * Primary Button Component
 * Based on official shadcn button block with default variant
 * Use for main actions like save, submit, search
 */
export const UIButtonPrimary = React.forwardRef<HTMLButtonElement, UIButtonPrimaryProps>(
  (props, ref) => {
    return (
      <UIButton
        variant="default"
        ref={ref}
        {...props}
      />
    )
  }
)

UIButtonPrimary.displayName = "UIButtonPrimary"